import type { AuthApi } from '@/api';

export type RouletteCategoryType = NonNullable<
  NonNullable<
    NonNullable<
      Parameters<
        (typeof AuthApi)['get:/wello/v1/auth/affiliate/partner-points/roulettes']
      >[0]
    >['query']
  >['categoryType']
>;

export const ROULETTE_CATEGORIES = [
  { value: 'CAFE_BEVERAGE', label: '커피/음료' },
  { value: 'DESSERT', label: '디저트' },
  { value: 'FAST_FOOD', label: '패스트푸드' },
  { value: 'CHICKEN', label: '치킨' },
] as const satisfies ReadonlyArray<{
  value: RouletteCategoryType;
  label: string;
}>;
